document.addEventListener("algolia.hooks.initialize", function () {

    function getMetaValue(hit, namespace, key) {
    const value = hit?.meta?.[namespace]?.[key];

    // Covers plain values and possible typed/value-shaped objects
    if (value && typeof value === "object" && "value" in value) {
      return value.value;
    }

      return value;
    }

    function isTruthyMeta(value) {
      return value === true ||
        value === "true" ||
        value === "1" ||
        value === 1 ||
        value === "yes";
    }

    function getMedisaveInventoryNote(hit) {
      const fixedLeadTime = getMetaValue(hit, "custom", "fixed_lead_time");
      const leadTime = getMetaValue(hit, "custom", "lead_time");
      const direct = getMetaValue(hit, "custom", "direct");

      const rawQty = hit.inventory_quantity;

      const hasQty =
        rawQty !== undefined &&
        rawQty !== null &&
        rawQty !== "";

      const qty = hasQty ? Number(rawQty) : null;

      const hasValidQty =
        hasQty &&
        !Number.isNaN(qty);

      const inventoryAvailable =
        hit.inventory_available === true ||
        hit.inventory_available === "true";

      const continuesSelling =
        String(hit.inventory_policy || "").toLowerCase() === "continue";

      const available =
        inventoryAvailable ||
        continuesSelling ||
        (hasValidQty && qty > 0);

      if (fixedLeadTime && available) {
        return {
          label: fixedLeadTime,
          className: "pos-stock"
        };
      }

      if (hasValidQty && qty > 100) {
        return {
          label: "100+ in stock",
          className: "pos-stock"
        };
      }

      if (hasValidQty && qty > 0) {
        return {
          label: `${qty} in stock`,
          className: "pos-stock"
        };
      }

      if (leadTime && available) {
        return {
          label: leadTime,
          className: "pos-stock"
        };
      }

      if (isTruthyMeta(direct)) {
        return {
          label: "SPECIAL ORDER",
          className: "pos-stock"
        };
      }

      /**
       * Important:
       * Only show BACKORDER if Algolia has actually returned inventory_quantity.
       * Otherwise missing stock data would make every available product look like BACKORDER.
       */
      if (hasValidQty && qty <= 0 && available) {
        return {
          label: "BACKORDER",
          className: "pos-stock pos-stock--backorder"
        };
      }

      return null;
    }

  /**
   * Collections to hide from the Collections section in autocomplete.
   * Use Shopify collection handles, e.g.
   * /collections/littmann-without-discount
   * becomes "littmann-without-discount"
   */
  const excludedCollectionHandles = new Set([
    "littmann-without-discount"
    // Add more handles here, for example:
    // "competition",
    // "clearance",
  ]);

  /**
   * Autocomplete product cards
   */
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (
      _defaultTemplate,
      templateOptions,
      distinct,
      itemLink,
      trackSearchAttribution
    ) {
      const { html, item, components } = templateOptions;
      const inventoryNote = getMedisaveInventoryNote(item);

      return html`
        <a
          href="${itemLink}"
          class="aa-ItemLink aa-ProductItem"
          onClick="${() => trackSearchAttribution(item)}"
        >
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img
                src="${algoliaShopify.helpers.renderImage(item, 125).src}"
                srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
                sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
                alt="${item.title}"
              />
            </div>

            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle medisave-aa-product-title">
                  ${components.Highlight({ hit: item, attribute: "title" })}
                  <span class="algolia-variant">
                    ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
                  </span>
                </div>
              </div>

              ${item.sku &&
              html`
                <div class="algolia-result-sku algolia-autocomplete-sku">
                  SKU: ${components.Highlight({ hit: item, attribute: "sku" })}
                </div>
              `}

              ${false && inventoryNote &&
              html`
                <div class="inventoryNote algolia-inventory-note">
                  <div class="${inventoryNote.className}">
                    <span class="stock-qty">${inventoryNote.label}</span>
                  </div>
                </div>
              `}

              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">
                  ${algoliaShopify.helpers.displayPrice(item, distinct)}
                </div>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );

  /**
   * InstantSearch product cards
   */
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
      return html`
        <div
          class="ais-hit ais-product"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
          onClick="${() => trackSearchAttribution(hit)}"
        >
          <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.mediumImage(hit)}"
              alt="${hit.title}"
            />
          </a>

          <div class="ais-hit--details">
            <p class="ais-hit--title">
              <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
                ${components.Highlight({ attribute: "title", hit })}
                ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
              </a>
            </p>

            ${hit.sku &&
            html`
              <p class="algolia-result-sku algolia-instantsearch-sku">
                SKU: ${components.Highlight({ attribute: "sku", hit })}
              </p>
            `}

            ${hit.vendor &&
            html`
              <p class="ais-hit--vendor">
                ${components.Highlight({ attribute: "vendor", hit })}
              </p>
            `}

            <p class="ais-hit--price">
              <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
            </p>
          </div>
        </div>
      `;
    }
  );


});